import { render, staticRenderFns } from "./SelectTrait.vue?vue&type=template&id=1c405372"
import script from "./SelectTrait.vue?vue&type=script&lang=js"
export * from "./SelectTrait.vue?vue&type=script&lang=js"
import style0 from "./SelectTrait.vue?vue&type=style&index=0&id=1c405372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports